import React from "react";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useIntl } from "react-intl";
import { AEButton } from "../../../../_emywork/components/buttons";
import { AESVG } from "../../../../_emywork/components/svg";

const Apply = ({
  handleSubmit,
  resetForm,
  setAdvancedFilter,
  advancedFilter,
}) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Dropdown as={ButtonGroup} className={"pl-2"}>
        <AEButton
          variant={"light"}
          fontWeight={"bolder"}
          onClick={handleSubmit}
        >
          <AESVG path={"/Navigation/Check.svg"} variant={"primary"} />
          {formatMessage({ id: "APPLY" })}
        </AEButton>
        <Dropdown.Toggle split variant="light-primary" />
        <Dropdown.Menu className={"py-5"}>
          <Dropdown.Item
            onClick={() => {
              resetForm();
              handleSubmit();
            }}
          >
            {formatMessage({ id: "RESET" })}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={(event) => {
              setAdvancedFilter(!advancedFilter);
            }}
          >
            {formatMessage({
              id: `FILTER.ADVANCED.${advancedFilter ? "LESS" : "MORE"}`,
            })}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default Apply;
